module.exports = __webpack_public_path__ + "static/img/rank_140.2d9cf40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_140.png
// module id = RxSF
// module chunks = 0